import { render, staticRenderFns } from "./DownloadInput.vue?vue&type=template&id=05f40067&scoped=true"
import script from "./DownloadInput.vue?vue&type=script&lang=ts"
export * from "./DownloadInput.vue?vue&type=script&lang=ts"
import style0 from "./DownloadInput.vue?vue&type=style&index=0&id=05f40067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f40067",
  null
  
)

export default component.exports